
(function(dW, dD, dHtml, $) {

    dW.ZP_VC_PROJECT_SLIDER = [];

    dW.addEventListener(dW.ZP_DEFAULT.ZP_EVENT_ELEMENTS_INIT, init);

    function init()  {

        dW.removeEventListener(dW.ZP_DEFAULT.ZP_EVENT_ELEMENTS_INIT, init);

        let dElements = document.querySelectorAll('.zp_project_slider ');

        for(let i = 0; i < dElements.length; i++) {

            dW.ZP_VC_PROJECT_SLIDER.push(new ProjectSlider(dElements[i]));

        }

    }

    class ProjectSlider {



        /**
         * Konstrukter des Parallax-Sliders
         * @param {object} root - Selektor: Parallax-Slider-Element-Container
         */
        constructor(root) {

            this.initElements(root);
            this.initData();
            this.init();

        }

        /**
         * Initialisiere das Hauptprogramm
         */
        init() {

            this.onSiteClick();
            this.addLinks();
            this.addTitlesAndIntroductions();

        }

        /**
         * Deklariere den Container selbst sowie sämtliche benötigten Elemente innerhalb des Sliders
         */
        initElements (root) {

            this.ELEMENTS = {
                root: root,
                html: dD.getElementsByTagName('html')[0],
                slideElements: root.getElementsByTagName('ct_amy_section'),
                sliderArrowLeft: root.getElementsByClassName('ct_amy_arrows_prev')[0].getElementsByTagName('i')[0],
                sliderArrowRight: root.getElementsByClassName('ct_amy_arrows_next')[0].getElementsByTagName('i')[0],
                cursorLeft: null,
                cursorRight: null
            };

        }

        /**
         * Deklariere alle via "data" mitgelieferten Informationen
         */
        initData () {

            this.DATA = {
                titles: JSON.parse(this.ELEMENTS.root.getAttribute('data-titles')),
                introductions: JSON.parse(this.ELEMENTS.root.getAttribute('data-introduction')),
                links: JSON.parse(this.ELEMENTS.root.getAttribute('data-links'))
            };

            // console.log(this.DATA);

        }

        addLinks () {

            let index = 0;
            console.log(this.ELEMENTS.slideElements);
            for (index ; index < this.ELEMENTS.slideElements.length ; index++) {
                let a = this.ELEMENTS.slideElements[index].getElementsByTagName('a')[0];
                console.log(a);
                console.log(this.DATA.links[index]);
                a.href = this.DATA.links[index];
            }

        }

        escapeHtml(text) {
            return text
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }

        addTitlesAndIntroductions () {


            let index = 0;
            for (index ; index < this.ELEMENTS.slideElements.length ; index++) {

                let layer = this.ELEMENTS.slideElements[index].getElementsByClassName('layer')[0];

                layer.insertAdjacentHTML('afterbegin', '' +
                    '<div class="title">' +
                    '<div class="zp-font zp-att-font-uppercase zp-att-font-weight-black font-black-background zp_text zp_element">' +
                    '<div class="zp-filter-text"><p>'+this.DATA.titles[index]+'</p>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="introduction">' +
                    '<div class="zp-font zp-att-font-uppercase zp-att-font-weight-bold font-black-background zp_text zp_element">' +
                    '<div class="zp-filter-text"><p>'+this.DATA.introductions[index]+'</p>' +
                    '</div>' +
                    '</div>' +
                    '</div>'
                );
            }

        }

        onSiteClick () {

            if (!ZP_UTIL.hasClass(this.ELEMENTS.html, 'zp-device-touch')) {
                this.ELEMENTS.root.insertAdjacentHTML('afterbegin', '' +
                    '<div class="cursor-left">' +
                    '</div>' +
                    '<div class="cursor-right">' +
                    '</div>'
                );
                this.ELEMENTS.cursorLeft = this.ELEMENTS.root.getElementsByClassName('cursor-left')[0];
                this.ELEMENTS.cursorRight = this.ELEMENTS.root.getElementsByClassName('cursor-right')[0];
                this.ELEMENTS.root.addEventListener('mousemove', (e) => {
                    let windowWidth = dW.innerWidth;
                    //linker Viewportbereich
                    if (e.clientX < windowWidth/2) {
                        this.ELEMENTS.root.classList.add('mouse-on-left');
                        this.ELEMENTS.root.classList.remove('mouse-on-right');
                    }
                    //rechter Viewportbereich
                    else {
                        this.ELEMENTS.root.classList.add('mouse-on-right');
                        this.ELEMENTS.root.classList.remove('mouse-on-left');
                    }
                    this.ELEMENTS.cursorLeft.style.top = e.clientY-15+'px';
                    this.ELEMENTS.cursorLeft.style.left = e.clientX-15+'px';
                    this.ELEMENTS.cursorRight.style.top = e.clientY-15+'px';
                    this.ELEMENTS.cursorRight.style.left = e.clientX-15+'px';
                });
                this.ELEMENTS.root.addEventListener('mouseleave', (e) => {
                    this.ELEMENTS.root.classList.remove('mouse-on-left');
                    this.ELEMENTS.root.classList.remove('mouse-on-right');
                });

                this.ELEMENTS.root.addEventListener('click', (e) => {
                    if (!ZP_UTIL.hasClass(e.target,'prev-arrow') && !ZP_UTIL.hasClass(e.target,'next-arrow')) {
                        // e.preventDefault();
                        // console.log(e.target);
                        // console.log(ZP_UTIL.hasClass(e.target.parentNode, 'ct_as_readmore'));


                        if (!ZP_UTIL.hasClass(e.target.parentNode, 'ct_as_readmore')) {
                            //linker Viewportbereich
                            if (ZP_UTIL.hasClass(this.ELEMENTS.root, 'mouse-on-left')) {
                                this.ELEMENTS.sliderArrowLeft.click();
                            }
                            //rechter Viewportbereich
                            else {
                                this.ELEMENTS.sliderArrowRight.click();
                            }
                        }

                    }
                })
            }

        }

    }

}(window, document, document.getElementsByTagName('html')[0], jQuery));